import React from "react"
import { NeutralTextLink } from "../../../ui/components/link/link.component"
import { SocialWrapper, Logo, SocialLinks, SocialIcon } from "./social.styled"
import facebookIcon from "../../../images/icons/facebook.svg"
import instagramIcon from "../../../images/icons/instagram.svg"
import pinterestIcon from "../../../images/icons/pinterest-footer.svg"
import twitterIcon from "../../../images/icons/twitter.svg"
import youtubeIcon from "../../../images/icons/youtube.svg"
import logo from "../../../images/layout/logo.svg"
import { Path } from "../../constants/routes"
import { AppFunctionComponent } from "../../../types"

type SocialProps = {
  logoPath: Path
}

const Social: AppFunctionComponent<SocialProps> = ({ logoPath }) => {
  return (
    <SocialWrapper>
      <NeutralTextLink to={logoPath}>
        <Logo src={logo} alt={"Mudita"} />
      </NeutralTextLink>
      <SocialLinks>
        <NeutralTextLink to={"https://www.facebook.com/wearemudita"}>
          <SocialIcon src={facebookIcon} alt={"Mudita on Facebook"} />
        </NeutralTextLink>
        <NeutralTextLink to={"https://twitter.com/wearemudita"}>
          <SocialIcon src={twitterIcon} alt={"Mudita on Twitter"} />
        </NeutralTextLink>
        <NeutralTextLink to={"https://pinterest.com/wearemudita/"}>
          <SocialIcon src={pinterestIcon} alt={"Mudita on Pinterest"} />
        </NeutralTextLink>
        <NeutralTextLink to={"https://www.youtube.com/MuditaBrand"}>
          <SocialIcon src={youtubeIcon} alt={"Mudita on YouTube"} />
        </NeutralTextLink>
        <NeutralTextLink to={"https://www.instagram.com/wearemudita/"}>
          <SocialIcon src={instagramIcon} alt={"Mudita on Instagram"} />
        </NeutralTextLink>
      </SocialLinks>
    </SocialWrapper>
  )
}

export default Social
